import { usePageMeta } from "@/lib/seo";
import { STORE_ADDRESS, STORE_PHONE } from "@/constants/store";

const S = ({ title, children }) => (
  <section className="mt-8">
    <h2 className="font-display font-bold text-lg text-[#0A1C40]">{title}</h2>
    <div className="mt-2 text-sm text-gray-700 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function PrivacyPage() {
  usePageMeta("Privacy Policy", "How IPVALUE MARKETPLACE collects, uses, and protects your information.");
  return (
    <div className="max-w-[860px] mx-auto px-6 py-12" data-testid="privacy-page">
      <div className="ipv-eyebrow text-[#0A1C40]">Policies</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-3">Privacy Policy</h1>
      <p className="text-sm text-gray-500 mt-3">IPVALUE MARKETPLACE LLC · {STORE_ADDRESS.short} · Last updated June 2026</p>

      <S title="What we collect">
        <p>When you shop with us we collect the information needed to complete your order: name, email, phone number, delivery address, and order details. If you create an account, we store your login email and order history. We never see or store your full card number — payments are processed by Square, and adult wellness &amp; tobacco accessory purchases are processed by Shopify.</p>
      </S>
      <S title="How we use it">
        <p>We use your information to process and deliver orders, send order confirmations and delivery-window texts, respond to your questions, and manage holds, deposits, and store credit. If you opt into text alerts (for example, new-load alerts), you can opt out any time by replying STOP.</p>
      </S>
      <S title="Discreet handling for age-restricted departments">
        <p>Purchases in our adult (18+) department are not recorded against your name in store records, appear as a plain line item on receipts, and discreet bagging and billing are available. Tobacco accessory purchases require a government photo ID (21+).</p>
      </S>
      <S title="What we share">
        <p>We share information only with the service providers who make your order work: Square and Shopify (payment processing), our delivery scheduling and messaging providers (order texts and emails), and Google Maps (calculating your delivery fee from your address). We do not sell your personal information.</p>
      </S>
      <S title="Your choices">
        <p>You can request a copy of your data, ask us to correct it, or ask us to delete your account information by calling {STORE_PHONE} or visiting us at {STORE_ADDRESS.short}. Text-message and email marketing are opt-in and can be cancelled at any time.</p>
      </S>
      <S title="Contact">
        <p>Questions about this policy? Call {STORE_PHONE} or visit us at {STORE_ADDRESS.short}.</p>
      </S>
    </div>
  );
}
